module.exports = __webpack_public_path__ + "media/images/riders/MARIANA_SALAZAR-6ee5942727ad0c99e49a8de4c22ba3b0.png";